import { AxiosResponse } from 'axios';
import * as EmeraldErrorCodes from '../../common/helpers/error-code';
import { EmeraldError } from './emerald-error';

export const parseCommunicationEmeraldErrors = (error: any): EmeraldError | undefined => {
  if (error.code === 'ECONNABORTED') {
    return new EmeraldError(EmeraldErrorCodes.CommunicationError, 'The BFF request timed-out');
  }

  if (!error.response) {
    return new EmeraldError(EmeraldErrorCodes.CommunicationError, 'BFF-Error');
  }

  const response = error.response as AxiosResponse;

  if (typeof response.data === 'string' && response.data.includes('ECONNREFUSED')) {
    return new EmeraldError(EmeraldErrorCodes.CommunicationError, 'BFF-Error');
  }

  if (response.status === 401) {
    return new EmeraldError(EmeraldErrorCodes.Unauthorized, 'Unauthorized');
  }

  if (response.status === 404) {
    return new EmeraldError(
      EmeraldErrorCodes.CommunicationError,
      `Could not reach BFF route ${error.config.url}`,
    );
  }

  if (response.status === 502) {
    return new EmeraldError(
      EmeraldErrorCodes.CommunicationError,
      'The Emerald Store request failed',
    );
  }

  if (response.status === 504) {
    return new EmeraldError(
      EmeraldErrorCodes.CommunicationError,
      'The Emerald Store request timed-out',
    );
  }

  if (response.status === 500) {
    return new EmeraldError(
      EmeraldErrorCodes.BFFInternalServerError,
      'Something went wrong, please contact your administrator',
    );
  }
};
